import './Actions.css'
import { useState } from 'react'
import Action from './Action'
import Button from 'react-bootstrap/Button'

function Actions({ actions, onSuccess, onClose }) {
    const [selectedAction, setAction] = useState()
    // console.log(actions)
    return (
        <>
            <div>
                <div className="map-buttons-wrapper">
                    {actions && Array.isArray(actions) && actions.length !== 0 &&
                        actions
                            .filter((action) => action.name === "create_dam" || action.name === "create_epicenter")
                            .map((action) => (
                                <Button
                                    variant="light"
                                    size="sm"
                                    key={action.name}
                                    onClick={() => setAction(action)}
                                >
                                    {action.title}
                                </Button>
                            ))}
                </div>

                <div className="buttons-wrapper">
                    {actions && Array.isArray(actions) && actions.length !== 0 &&
                        actions
                            .filter((action) => action.name === "update" || action.name === "update_epicenter" ||  action.name === "add_image")
                            .map((action) => (
                                <Button
                                    variant="outline-primary"
                                    size="default"
                                    key={action.name}
                                    onClick={() => setAction(action)}
                                >
                                    {action.title}
                                </Button>
                            ))}
                </div>
                <div className="buttons-wrapper">
                    {actions && Array.isArray(actions) && actions.length !== 0 &&
                        actions
                            .filter((action) => action.name === "add_acl" || action.name === "add_freq" || action.name === "add_fem")
                            .map((action) => (
                                <Button
                                    variant="outline-primary"
                                    size="default"
                                    key={action.name}
                                    onClick={() => setAction(action)}
                                >
                                    {action.title}
                                </Button>
                            ))}
                </div>
                <div className="buttons-wrapper">
                    {actions && Array.isArray(actions) && actions.length !== 0 &&
                        actions
                            .filter((action) => action.name === "add_supervisor" || action.name === "remove_supervisor")
                            .map((action) => (
                                <Button
                                    variant="outline-primary"
                                    size="default"
                                    key={action.name}
                                    onClick={() => setAction(action)}
                                >
                                    {action.title}
                                </Button>
                            ))}
                </div>


                <div className="buttons-wrapper">
                    {actions && Array.isArray(actions) && actions.length !== 0 &&
                        actions
                            .filter((action) => action.name === "delete")
                            .map((action) => (
                                <Button
                                    variant="danger"
                                    size="default"
                                    key={action.name}
                                    onClick={() => setAction(action)}
                                >
                                    {action.title}
                                </Button>
                            ))}
                </div>
            </div>


            <div className='action'>
                {selectedAction !== undefined &&
                    <Action action={selectedAction}
                        closeAction={() => {
                            setAction(undefined)
                            onClose && onClose()
                        }}
                        onSuccess={() => {
                            onSuccess && onSuccess()
                            //alert(`${selectedAction.name} was successful`)
                        }} />}
            </div>
        </>
    )
}

export default Actions